import React from 'react';
import YearItem from './YearItem';
import YearSelectPanelLayout from './YearSelectPanelLayout';
// tslint:disable-next-line:no-any
export default function YearSelectPanel(props) {
    var yearArr = getYearDate(props.yearChecked, props.prevAndNext, props.modelState);
    var nowYear = new Date().getFullYear();
    return (React.createElement(YearSelectPanelLayout, null, yearArr.map(function (yearNum) {
        if (props.yearLastChecked === yearNum &&
            props.isLastChecked &&
            nowYear === yearNum) {
            return (React.createElement(YearItem, { title: yearNum, selectYear: props.selectYear, checked: true, sameYear: true }));
        }
        if (props.yearLastChecked === yearNum && props.isLastChecked) {
            return (React.createElement(YearItem, { title: yearNum, selectYear: props.selectYear, checked: true }));
        }
        if (nowYear === yearNum) {
            return (React.createElement(YearItem, { title: yearNum, selectYear: props.selectYear, sameYear: true }));
        }
        if (props.yearChecked === yearNum) {
            return (React.createElement(YearItem, { title: yearNum, selectYear: props.selectYear, enable: true }));
        }
        else {
            return React.createElement(YearItem, { title: yearNum, selectYear: props.selectYear });
        }
    })));
}
function getYearDate(yearChecked, prevAndNext, modelState) {
    var yearArr = [];
    var remainderYear = yearChecked % 24;
    var pageFirstYear = yearChecked - remainderYear;
    var changePageFirstYear = pageFirstYear + 24 * prevAndNext;
    if (changePageFirstYear <= 2) {
        changePageFirstYear = 1990;
    }
    for (var i = changePageFirstYear; i < changePageFirstYear + 24; i++) {
        yearArr.push(i);
    }
    return yearArr;
}
//# sourceMappingURL=YearSelectPanel.js.map